import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { requiredLabel, useCreateProfileFieldStyles } from './field-styles'

const SelectionGroup = ({
  title,
  description,
  children,
  hideHeader = false,
  icon: Icon,
  required = false,
}) => {
  const classes = useCreateProfileFieldStyles()

  return (
    <Box className={classes.selectionCard}>
      {!hideHeader && title ? (
        <Box className={classes.selectionCardHeader}>
          <Box className={classes.selectionCardHeaderRow}>
            {Icon ? (
              <Box className={classes.selectionIconCircle}>
                <Icon />
              </Box>
            ) : null}
            <Box className={classes.selectionCardHeaderText}>
              <Typography
                component="h4"
                variant="inherit"
                className={classes.selectionCardTitle}
              >
                {required ? requiredLabel(title) : title}
              </Typography>
              {description ? (
                <Typography
                  component="p"
                  variant="inherit"
                  className={classes.selectionCardDescription}
                >
                  {description}
                </Typography>
              ) : null}
            </Box>
          </Box>
        </Box>
      ) : null}
      <Box className={classes.selectionCardBody}>{children}</Box>
    </Box>
  )
}

SelectionGroup.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  hideHeader: PropTypes.bool,
  icon: PropTypes.elementType,
  required: PropTypes.bool,
}

export default SelectionGroup
